
angular.module('changeLog', ['ui.router'])
